export function shouldPredict(key, options) {
    if (key in options)
        return true;
    const heteroRequired = 'hsqc' in options || 'hmbc' in options;
    return key === 'C'
        ? heteroRequired
        : key === 'H'
            ? heteroRequired || 'cosy' in options
            : false;
}
//# sourceMappingURL=shouldPredict.js.map